import React from 'react';
import styled from '@emotion/styled';

/**
 * DistributionBar — one statement's spread on the 1–5 scale as a stacked
 * bar for the wall: five segments from disagree to agree, "en osaa sanoa"
 * as a grey tail, the mean as a number. Reads at a distance; no legend
 * needed once the colours are learnt from the first bar.
 */
const Row = styled.div`display: grid; grid-template-columns: minmax(0, 1fr) 4.5rem; gap: 1.2rem; align-items: center;`;
const Text = styled.div`font-size: ${(p) => p.$size}; line-height: 1.3; color: #e8ecf2; margin-bottom: 0.5rem;`;
const Bar = styled.div`display: flex; height: ${(p) => p.$height}; border-radius: 8px; overflow: hidden; background: #1a1f2a;`;
const Seg = styled.div`
  flex: 0 0 ${(p) => p.$share * 100}%; background: ${(p) => p.$c}; display: grid; place-items: center;
  font-size: 0.85rem; font-weight: 700; color: rgba(0, 0, 0, 0.7); transition: flex-basis 0.4s;
`;
const Mean = styled.div`font-size: 2rem; font-weight: 700; color: #e8ecf2; text-align: right; font-variant-numeric: tabular-nums; small { display: block; font-size: 0.7rem; font-weight: 400; color: #7b8794; }`;

export const SCALE_COLORS = { 1: '#e05a5a', 2: '#e9a06a', 3: '#c9cbd6', 4: '#7fc8a9', 5: '#3fbf8f', unknown: '#3a4457' };

/**
 * @param {{ text: string, shares: Record<1|2|3|4|5|'unknown', number>, counts?: Record<string, number>, mean: number|null, meanLabel?: string, size?: string, height?: string }} props
 */
export default function DistributionBar({ text, shares, counts = null, mean = null, meanLabel = '', size = '1.25rem', height = '2.2rem' }) {
  const keys = [1, 2, 3, 4, 5, 'unknown'];
  return (
    <div>
      <Text $size={size}>{text}</Text>
      <Row>
        <Bar $height={height} role="img" aria-label={text}>
          {keys.map((k) => (shares?.[k] > 0 ? <Seg key={k} $share={shares[k]} $c={SCALE_COLORS[k]} title={`${k}: ${counts?.[k] ?? ''}`}>{shares[k] >= 0.12 ? (counts?.[k] ?? '') : ''}</Seg> : null))}
        </Bar>
        <Mean>{mean === null || mean === undefined ? '–' : mean.toFixed(1)}<small>{meanLabel}</small></Mean>
      </Row>
    </div>
  );
}
